"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { useNativeHomeExperience } from "./native-simple-home";

type NativeHomeShellProps = {
  children: ReactNode;
  navigation: ReactNode;
  footer: ReactNode;
};

export function NativeHomeShell({
  children,
  navigation,
  footer,
}: NativeHomeShellProps) {
  const pathname = usePathname();
  const isNativeHome = useNativeHomeExperience();
  const showMarketingChrome = pathname !== "/" || !isNativeHome;
  // The launch screen already sits under the status-bar inset. Locking it
  // to the viewport keeps the footer on screen; min-h-dvh inside that inset
  // used to push the footer below the fold.
  const lockViewport = !showMarketingChrome;

  return (
    <div
      className={`${
        lockViewport ? "flex h-dvh flex-col overflow-hidden" : "min-h-screen"
      } bg-(--mk-ink) text-(--mk-cream) antialiased ${
        showMarketingChrome
          ? ""
          : "bg-[radial-gradient(ellipse_120%_65%_at_50%_-8%,rgba(201,168,76,0.28),transparent_58%)]"
      }`}
    >
      {showMarketingChrome ? (
        <div
          className="pointer-events-none fixed inset-0 z-9999 opacity-35"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E")`,
          }}
        />
      ) : null}
      {showMarketingChrome ? navigation : null}
      <div
        className={`flex flex-col ap-pad-safe-top ${
          lockViewport ? "min-h-0 flex-1" : ""
        }`}
        id="main-content"
      >
        {children}
      </div>
      {showMarketingChrome ? footer : null}
    </div>
  );
}
